import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { PropertyListener } from '@vsolv/dev-kit/rx';
import { ReplaySubject, switchMap } from 'rxjs';
import { WarrantyCustomerPortalService } from '../../../services';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'ws-warranty-picker',
  templateUrl: './warranty-picker.component.html',
  standalone: false,
})
export class WarrantyPickerComponent {
  constructor(private warrantySvc: WarrantyCustomerPortalService) {}

  @Input() contractNumber?: string;

  @Input() customerId?: string;
  @PropertyListener('customerId') private customerId$ = new ReplaySubject<string | undefined>(1);

  readonly warranties$ = this.customerId$.pipe(
    switchMap(async _customerId => {
      return (await this.warrantySvc.list({ limit: 100 })).items;
    })
  );

  isOpen = false;
}
